import firebase from 'firebase'
import {
  mapGetters
} from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'userProfile'
    ])
  },
  methods: {
    getUserProfile () {
      const currentUser = firebase.auth().currentUser
      this.$store.dispatch('getUserInfo', currentUser)
    }
  },
  mounted () {
    this.getUserProfile()
    console.log(this.trips)
  },
}



// WEBPACK FOOTER //
// ./src/components/header/header.js